// Module
var code = "<ul> {{#each wrong_input}} <li style=\"color:gray\"> {{this}} </li> {{/each}} </ul> ";
// Exports
export default code;